import { lenis } from '../util/lenis';

const initSiteMenu = () => {

  const openSiteMenu = () => {
    document.documentElement.classList.add('state--menu-slideout-open');

    if(lenis) {
      lenis.stop();
    }
  };

  const closeSiteMenu = () => {
    document.documentElement.classList.remove('state--menu-slideout-open');

    if(lenis) {
      lenis.start();
    }
  };

  document.querySelectorAll('[data-menu-slideout-open]').forEach((openBtn) => {
    openBtn.addEventListener('click', openSiteMenu);
  });

  document.querySelectorAll('[data-menu-slideout-close]').forEach((closeBtn) => {
    closeBtn.addEventListener('click', closeSiteMenu);
  });
};

export { initSiteMenu };